import React, { FC } from 'react';

import { Member } from '@/shared/api/organization';
import { Action, useModal, useOrganizationId, useSendInvites } from '@/features/Modals';
import { Button, ButtonVariant } from '@/shared/ui';

export const ResendInviteModal: FC = () => {
    const { modalProps } = useModal();
    const { user }: { user: Member } = modalProps || {};
    const id = useOrganizationId();
    const { sendInvites, handleCloseModal } = useSendInvites(Action.RESEND);

    const handleCancel = () => {
        handleCloseModal();
    };

    const handleSendInvites = async () => {
        const description = `Successfully recent ${user.email} invite`;
        sendInvites({
            id,
            invites: [user],
            description,
        });
    };

    return (
        <div className='flex flex-col min-w-[500px] mt-5'>
            <div className='flex justify-end self-stretch gap-3 mt-7'>
                <Button
                    variant={ButtonVariant.Secondary}
                    className='flex items-center justify-center px-4 py-[10px] text-md'
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    variant={ButtonVariant.Primary}
                    className='flex items-center justify-center px-4 py-[10px] gap-2 text-md'
                    onClick={handleSendInvites}
                >
                    Resend Invite
                </Button>
            </div>
        </div>
    );
};
